import React, { useState, useEffect } from 'react';
import './Profile.css';
import { useNavigate } from 'react-router-dom';
import { getMe, updateProfile } from '../../api/loginAPI'; // Make sure this API fetches the user session
import { toast } from 'react-toastify';

function Profile() {
  const navigate = useNavigate();
  const [editing, setEditing] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);


  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    name: '',
    phone: '',
    companyAddress: '',
    email: '',
    role: '',
    createdAt: ''
  });

  useEffect(() => {
    async function fetchUser() {
      const user = await getMe();
      if (user) {
        setFormData({
          firstName: user.firstName || '',
          lastName: user.lastName || '',
          name: user.name || '',
          phone: user.phone || '',
          companyAddress: user.companyAddress || '',
          email: user.email || '',
          role: user.role || '',
          createdAt: new Date(user.createdAt).toLocaleDateString('en-IN', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          })
        });
      }
    }

    fetchUser();
  }, []);

  const handleInputChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    setIsUpdated(true);
  };

 const handleSave = async () => {
    const jwt = localStorage.getItem('jwt');
    const payload = {
      name: formData.name,
      phone: formData.phone,
      companyAddress: formData.companyAddress
    };

    const result = await updateProfile(payload, jwt);
    if (result.success !== false) {
      toast.success('Profile updated successfully!');
      setEditing(false);
      setIsUpdated(false);
    } else {
      toast.error(result.message || 'Failed to update profile');
    }
  };


  return (
    <div className="page profile-layout">
      <h2 className="profile-title">Welcome, {formData.name || 'User'}</h2>
      <p className="profile-subtext">Joined on {formData.createdAt}</p>

      <div className="profile-section">
        <h4>Personal Details</h4>
        <p className="section-description">Manage your personal identity across EarthID</p>
        <div className="info-card">
          <div className="info-row">
            <span className="label">Full Name</span>
            {editing ? (
              <input
                name="name"
                value={formData.name}
                onChange={handleInputChange}
              />
            ) : (
              <span className="value">{formData.name}</span>
            )}
          </div>
          <div className="info-row">
            <span className="label">Phone Number</span>
            {editing ? (
              <input
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
              />
            ) : (
              <span className="value">{formData.phone || 'N/A'}</span>
            )}
          </div>
          <div className="info-row">
            <span className="label">Company Address</span>
            {editing ? (
              <input
                name="companyAddress"
                value={formData.companyAddress}
                onChange={handleInputChange}
              />
            ) : (
              <span className="value">{formData.companyAddress || 'N/A'}</span>
            )}
          </div>
          <div className="action-row">
            {editing ? (
              <button className="gradient-btn" onClick={handleSave} disabled={!isUpdated}>
                Save
              </button>
            ) : (
              <button className="gradient-btn" onClick={() => setEditing(true)}>
                Change Details
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="profile-section">
        <h4>Login and Security</h4>
        <p className="section-description">Manage your login credentials and roles</p>
        <div className="info-grid">
          <div className="info-card">
            <div className="info-row">
              <span className="label">Email Address</span>
              <span className="value">{formData.email}</span>
            </div>
            <div className="info-row">
              <span className="label">Role</span>
              <span className="value">{formData.role}</span>
            </div>
            {/* <div className="action-row">
              <button className="gradient-btn" disabled>Change Email</button>
            </div> */}
          </div>

          <div className="info-card">
            <div className="info-row">
              <span className="label">Password</span>
              <span className="value">Password never changed</span>
            </div>
            <div className="action-row">
              <button
                className="gradient-btn"
                onClick={() => navigate('/profile/change-password')}
              >
                Change Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
